import { toast } from "sonner";

/**
 * Celebrate any badges unlocked by a just-completed action. The create/sync
 * endpoints return the keys awarded on that call; we surface them as a toast so
 * earning a badge feels like a reward, not a silent DB write.
 */
export function announceBadges(newBadges: string[]): void {
	if (newBadges.length === 0) return;
	if (newBadges.length === 1) {
		toast.success("🏅 Badge unlocked!", { description: "Check your dashboard to see it." });
	} else {
		toast.success(`🏅 ${newBadges.length} badges unlocked!`, {
			description: "Check your dashboard to see them.",
		});
	}
}
